import { apiUtil } from 'lifesci-ui'

const { getApiPathPrefix, request } = apiUtil

function path() {
  return `${getApiPathPrefix('VITE_APP_BASE_PATH_ADMIN')}`
}

export function settingList() {
  return request({
    url: `${path()}/setting/list`,
    method: 'post'
  })
}


export function settingGet(key: string) {
  return request({
    url: `${path()}/setting/get`,
    method: 'post',
    params: { key }
  })
}


export function getSetting(type: string, key: string) {
  return request({
    url: path() + '/setting/getValue',
    method: 'post',
    params: { type, key }
  })
}



export async function initSetting() {

  const env_client = await getSetting("env", "env_client")
  localStorage.setItem("env_client", env_client)



  const type = "animal_config"
  const keyList = ["animal_delivery", "protocol_examine", "animal_no_project", "animal_no_study", "request_transportbox"]

  keyList.forEach(async key => {
    const value = await getSetting(type, key)
    localStorage.setItem(key, value)
  })
}